import * as React from "react"
import {User, UserState} from "../../store/user/types";
import {OverviewArticle} from "../../store/article/types";
import {connect} from "react-redux";
import {AppState} from "../../store";
import HamaTable from "../../common/component/HamaTable";
import greenCircle from "../../common/icons/green_circle.gif";
import redCircle from "../../common/icons/red_circle.gif";
import axios from "axios";
import {WithTranslation, withTranslation} from "react-i18next";
import {withRouter, RouteComponentProps, Route} from "react-router-dom";
import {compose} from "redux";
import AlertDialog from "../../common/component/AlertDialog";
import Alert from "../../common/component/Alert";
import Breadcrumbs from "@material-ui/lab/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import ReachElements from "./ReachElements";
import ReachParts from "./ReachParts";
import {createStyles, Theme, WithStyles, withStyles} from "@material-ui/core";
import {setReachElementsAndErrors} from "../../store/reach/actions";

// Component own properties
type ReachProps = RouteComponentProps & WithTranslation & WithStyles & {
    userState: UserState,
    setReachElementsAndErrors: typeof setReachElementsAndErrors;
}

interface IReachState {
    articles: Array<OverviewArticle>;
    selectedArticles: Array<OverviewArticle>;
    showDeclarationSvhcQuestion: boolean;
    showThankYouDialog: boolean;
    showError: boolean;
    errorMessage: string;
    isLoading: boolean;
}

class Reach extends React.Component<ReachProps, IReachState> {

    state = {
        articles: new Array<OverviewArticle>(),
        selectedArticles: new Array<OverviewArticle>(),
        showDeclarationSvhcQuestion: false,
        showThankYouDialog: false,
        showError: false,
        errorMessage: '',
        isLoading: true
    }

    render() {
        const t = this.props.t;
        const path = this.props.location.pathname;
        const editAllowed = !(this.props.userState === undefined || this.props.userState.user === undefined || this.props.userState.user.login === 'pmstab' ? true : false);
        return (
            <div>
                <Breadcrumbs separator={<NavigateNextIcon fontSize="small"/>} arial-label="Breadcrumb"
                             className={this.props.classes.breadcrumbs}>
                    <Typography
                        color={path.endsWith('eutr') ? 'textPrimary' : 'textSecondary'}>{t('Reach.title')}</Typography>
                    {path.indexOf('elements') != -1 &&
                    <Typography
                        color={path.endsWith('elements') ? 'textPrimary' : 'textSecondary'}>{t('ReachElements.title')}</Typography>}
                    {path.indexOf('parts') != -1 &&
                    <Typography
                        color={path.endsWith('parts') ? 'textPrimary' : 'textSecondary'}>{t('ReachParts.title')}</Typography>}
                </Breadcrumbs>

                <Route exact
                       path={'/app/reach'}
                       render={() => ([
                           <HamaTable key="ReachTable" selectable={editAllowed} t={t} data={this.state.articles} title='ReachTable' isLoading={this.state.isLoading}
                                      converter={[{
                                          property: 'upToDate',
                                          convert: this.convertBooleanToIcon
                                      }]}
                                      buttons={[{
                                          title: this.props.t('Reach.createDeclaration'),
                                          selectionMulti: true,
                                          onClick: this.createElements.bind(this)
                                      }]}/>,
                           <AlertDialog key="Reach.declarationSvhcQuestionTitle"
                                        title={t('Reach.declarationSvhcQuestionTitle')}
                                        message={t('Reach.declarationSvhcQuestionMessage')}
                                        buttons={[{label: t('common.yes'), value: true}, {
                                            label: t('common.no'),
                                            value: false}, {label: t('common.cancel'), value: 'cancel'}]}
                                        isOpen={this.state.showDeclarationSvhcQuestion}
                                        onClose={this.onCreateElementsSvhcConfirm}/>,
                           <Alert key="ErrorDialog" open={this.state.showError} message={this.state.errorMessage} vertical="top"
                                  onClose={() => this.setState({showError: false})} type='error'/>,
                            <AlertDialog key="ThankYou"
                                  title={t('Reach.thankYouTitle')}
                                  message={t('Reach.thankYouText')}
                                  buttons={[{label: t('common.ok'), value: true}]}
                                  isOpen={this.state.showThankYouDialog}
                                  onClose={() => this.setState({showThankYouDialog: false})}/>                
                       ])}/>
                <Route exact
                       path={`${this.props.match.url}/elements`}
                       render={() => <ReachElements/>}/>
                <Route exact
                       path={`${this.props.match.url}/elements/parts`}
                       render={() => <ReachParts/>}/>
            </div>
        );
    }

    convertBooleanToIcon(input: any) {
        return <img src={input === true ? greenCircle : redCircle} height="auto"/>
    }

    componentWillMount() {
        this.loadArticles();
    }

    componentDidMount(): void {
        document.title = this.props.t('Reach.doctitle')
    }

    loadArticles() {
        let url = process.env.REACT_APP_SUPPLIER_SERVER_URL + '/suppliers/' + this.props.userState.user!.supplierId + '/articles';
        axios.get(url)
            .then(res => {
                if (res.status == 200) {
                    if (res.data) {
                        console.log('Loaded ' + res.data.length + ' reach articles');
                        this.setState({articles: res.data});
                        if(res.data.length == 0){
                            this.setState({showError: true, errorMessage: this.props.t('Reach.noArticlesFound')});
                        }
                    } else {
                        console.log('Failed to get reach articles: no data!');
                        this.setState({articles: []});
                    }
                } else {
                    console.log('Failed to get reach articles: server error ' + res.status + '!');
                    this.setState({articles: []});
                }
                this.setState({isLoading: false});
            })
            .catch(err => {
                console.log('Failed to get reach articles: server error');
                console.log(err);
                this.setState({articles: []});
                this.setState({isLoading: false});
            })
    }

    createElements(selected: Array<OverviewArticle>) {
        this.setState({selectedArticles: selected, showDeclarationSvhcQuestion: true});
    }

    onCreateElementsSvhcConfirm = (value: boolean) => {
        this.setState({showDeclarationSvhcQuestion: false});
        console.log('svhc answer is ' + value);
        if (value === true) {
            this.props.setReachElementsAndErrors({elements: [], errors: []}); // clean previous state
            this.props.history.push({
                pathname: `${this.props.match.url}/elements`,
                state: {articles: this.state.selectedArticles}
            });
        } else if (value === false) {
            this.createElementsWithoutSvhc();
        } else {
            // do nothing
        }
    }

    createElementsWithoutSvhc = () => {
        let url = process.env.REACT_APP_SUPPLIER_SERVER_URL + '/suppliers/' + this.props.userState.user!.supplierId + '/bulk/reachdeclarations';
        let articleNumbers = this.state.selectedArticles.map(a => a.icin);
        axios.post(url, {articleNumbers: articleNumbers})
            .then(res => {
                if (res.status == 201) {
                    console.log('Saved reach elements without svhc of ' + articleNumbers);
                    this.loadArticles();
                    this.setState({showThankYouDialog: true});
                } else {
                    console.log('Failed to save reach elements without svhc: ' + res.status + '!');
                    this.setState({showError: true, errorMessage: this.props.t('Reach.declarationCreationFailed')});
                }
            })
            .catch(err => {
                console.log('Failed to save reach elements without svhc');
                console.log(err);
                this.setState({showError: true, errorMessage: this.props.t('Reach.declarationCreationFailed')});
            });
    }
}

const styles = ({palette, spacing}: Theme) => createStyles({
    breadcrumbs: {
        margin: spacing.unit
    }
});

const mapStateToProps = (state: AppState) => ({
    userState: state.user,
});

export default compose(
    withRouter,
    withStyles(styles),
    withTranslation('common'),
    connect(mapStateToProps, {setReachElementsAndErrors})
)(Reach) as any;